import { Box, CircularProgress, TablePagination } from "@mui/material";
import ProductTable from "./ProductTable";

export default function ProductList({
  rows,
  loading,
  page,
  rowsPerPage,
  total,
  onPageChange,
  onRowsPerPageChange,
  getLineForLot,
  getPriceOverride,
  onAdd,
  onPriceConfig,
  disabled,
}) {
  return (
    <Box>
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress size={32} sx={{ color: "#e90000" }} />
        </Box>
      )}
      {!loading && (
        <ProductTable
          rows={rows}
          getLineForLot={getLineForLot}
          getPriceOverride={getPriceOverride}
          onAdd={onAdd}
          onPriceConfig={onPriceConfig}
          disabled={disabled}
        />
      )}
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[10, 20, 50]}
      />
    </Box>
  );
}
